import { firestore } from './firebase';
import { collection, getDocs } from 'firebase/firestore';

export const getUserCount = async () => {
    const userCollection = collection(firestore, 'users');
    const querySnapshot = await getDocs(userCollection);
    return querySnapshot.size;
};
